import React from 'react'

class DashboardBenefit extends React.Component {
  constructor () {
    super ()
    this.detailViewBenefits = [
      gon.company_variables.job_protected_leave || 'Job Protected Leave',
      gon.company_variables.paid_leave || 'Paid Leave'
    ];
    this.state = {
      selectedBenefit: {}
    }
  }

  buildClassName (benefit) {
    return `dashboard-benefit ${this.presenceClass(benefit)} ${this.additionalClass(benefit)}`
  }

  presenceClass (benefit) {
    return benefit.type !== 'empty' ?
      'present' : ''
  }

  additionalClass (benefit) {
    return(['elimination', 'holiday', 'pending-benefit', 'extending-benefit-range', 'unpaid-leave', 'extended-waiting-period'].indexOf(benefit.type) >= 0 ?
      benefit.type
    : '')
   }

  showBenefitName (e) {
    let currentTarget = e.currentTarget
    let targetDiv = $(currentTarget).find('.hovered-benefit-name');
    let frame;
    if ($(currentTarget).closest('.admin-container').length){
      frame = '.admin-container'
    } else {
      frame = '#page-content-wrapper';
    }
    $.fitInFrame(frame, targetDiv)
  }

  openModalBox (benefit) { 
    if (!benefit.no_pop_up && benefit.type !== 'elimination') {
      if (benefit.just_looking && !this.props.isAdmin){
        this.props.handleJustLookingClick(true)
      } else {
        let endpoint = ''
        if (benefit.type === 'exhaustion') {
          let elements = document.getElementsByClassName('time_off_type')
          let ids = [];
          for(let i = 0; i < elements.length; i++) {
            ids.push(elements[i].firstElementChild.id)
          }
          endpoint = `/exhaustion_periods/${benefit.id}/fetch_details/?time_off_leave_type_ids=[${ids}]`
        } else {
          let benefit_id = benefit.id
          if(benefit.records && benefit.records.length) {
            benefit_id = benefit.records[0].id
            this.setState({
              selectedBenefit: benefit.records[0]
            })
          }
          endpoint = `/leave_plan_benefits/${benefit_id}/fetch_details`
        }
        $.getJSON(endpoint, (data) => {
          gon.company_variables = {...gon.company_variables, ...data.statutory_substitutions_options}
          this.props.handleBenefitDetail({
            display_modal: true,
            data: data,
            selectedBenefit: this.state.selectedBenefit,
            name: data.name,
            description: data.description,
            image_url: data.image_url,
            isAdmin: data.isAdmin,
            displayBenefit: benefit,
            time_off_enabled: data.time_off_enabled,
            pending: data.pending,
            timelineItems: data.timeline_items,
          })
        })
      }
    }
  }

  detailViewHandler (benefit) {
    if (this.detailViewBenefits.indexOf(benefit.name) > -1) {
      this.props.toggleDetailView('graphView', 'detail')
    }
  }
  buildHoverName() {
    return `${this.props.benefit.hover_name || ''}${this.props.benefit.extendable_hover_name || ''}`
  }

  customColor() {
    const { customColor } = this.props
    return customColor && customColor.length > 0 ? customColor : ''
  }

  shadeColor(color, amount) {
    return (
      '#' + color.replace(/^#/, '').replace(/../g, color => (
          '0' + Math.min(255, Math.max(0, parseInt(color, 16) + amount)).toString(16)).substr(-2))
    )
  }

  render () {
    let color = this.customColor();

    const benefitDivStyle = {
      backgroundColor: color,
      borderLeft: color ? `1px solid ${this.shadeColor(`${color}`, -40)}`: '',
      borderRight: color ? `1px solid ${this.shadeColor(`${color}`, -40)}` : ''
    };

    const benefitHoverStyle = {
      color: color,
      border: color ? `1px solid ${this.shadeColor(`${color}`, -40)}` : ''
    };

    return (
      <div className='dashboard-benefit-div' style={{ width: this.props.benefit.width }}>
        <div
          className={this.buildClassName(this.props.benefit)}
          id={`dashboard-benefit-${this.props.benefit.id}`}
          style={benefitDivStyle}
          onClick={() => this.detailViewHandler(this.props.benefit)}
        >
          <div className='draggable-helper' />
          <div className='benefit-name-div' onMouseEnter={(e) => this.showBenefitName(e)}>
            <span className='benefit-name' onClick={() => this.openModalBox(this.props.benefit)}>
              {this.props.benefit.name}
            </span>
            <div className='hovered-benefit-name'
              style={benefitHoverStyle}
              dangerouslySetInnerHTML={{__html: this.buildHoverName()}}
              onClick={() => this.openModalBox(this.props.benefit)}
            />
          </div>
        </div>
        <div className='spinner-div' id={`spinner-div-${this.props.benefit.id}`} />
      </div>
    )
  }
}

export default DashboardBenefit